import { render, staticRenderFns } from "./RBCParam.vue?vue&type=template&id=58f43864&"
import script from "./RBCParam.vue?vue&type=script&lang=js&"
export * from "./RBCParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports